import * as React from 'react';
import b_ from 'b_';
import { useDispatch } from 'react-redux';
import Modal from '../Modal';
import { useTranslation } from 'react-i18next';
import { actions } from '../../actions/app';

import './index.scss';

import * as iconSuccess from './static/img/success.svg';

const b = b_.with('success-deposit-modal');

export const SuccessDepositModal: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const close = () => dispatch(actions.toggleDepositSuccessModal(false));

  return (
    <Modal className={b()} onClose={close} data-testid="withdraw-submitted-modal">
      <div className={b('content')}>
        <img src={iconSuccess} className={b('image')} alt="" />
        <h2 className={b('title')}>{t('Order accepted')}</h2>
        <p className={b('text')}>
          {t('The money will appear on the account as soon as the payment is processed')}
        </p>
        <a href="/investments" className={b('btn')} onClick={close}>
          {t('Go to investment ideas')}
        </a>
      </div>
    </Modal>
  );
};
